
import Vue from "vue";
import { mapGetters } from "vuex";
import InformationOutlineIcon from "icons/InformationOutline.vue";

export default Vue.extend({
  components: {
    InformationOutlineIcon,
  },
  computed: {
    ...mapGetters("billingModule", ["invoiceUrl"]),
  },
  async created() {
    // billingInfoを取得してストアに保存
    await this.$store.dispatch("billingModule/fetchBillingInfo");
  },
});
